import axios from 'axios';
import { getStoredLanguageOrDefault } from '../translations';

// Automatiškai nustatyti API URL produkcijoje
// React build procesas "bake-in" process.env reikšmes build metu
// Todėl naudojame window.location arba relatyvų kelią

const getApiUrl = () => {
  // Jei yra REACT_APP_API_URL, naudoti jį (nustatomas build metu)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Produkcijoje visada naudoti relatyvų kelią
  // React Scripts build visada nustato NODE_ENV=production
  // Bet jei build'as vykdomas be production flag, naudos development
  if (typeof window !== 'undefined') {
    // Naršyklėje - visada naudoti relatyvų kelią
    return '/api';
  }
  
  // Server-side rendering (jei būtų) - development
  return 'http://localhost:3000/api';
};

const API_URL = getApiUrl();

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Pridėti tokeną, session ID ir kalbą prie užklausų (kalba – banko pavedimo instrukcijoms ir kt.)
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const sessionId = localStorage.getItem('sessionId');
  if (sessionId) {
    config.headers['x-session-id'] = sessionId;
  }

  if (typeof window !== 'undefined') {
    const lang = getStoredLanguageOrDefault();
    if (lang && (lang === 'lt' || lang === 'en' || lang === 'de')) {
      config.headers['x-preferred-language'] = lang;
    }
  }

  return config;
});

// Išsaugoti session ID ir apdoroti 401 (nebegaliojantis/trūkstamas tokenas)
apiClient.interceptors.response.use(
  (response) => {
    if (response.data.sessionId) {
      localStorage.setItem('sessionId', response.data.sessionId);
    }
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const config = error.config;
    const isAuthRequest = config?.url && (
      config.url.includes('/auth/login') ||
      config.url.includes('/auth/register')
    );
    if (status === 401 && !isAuthRequest && typeof window !== 'undefined') {
      // Nesinukreipti į login, kai 401 gautas iš „pasirinktų“ endpointų, kuriuos kviečia ir svečiai (pvz. mėgstamų tikrinimas)
      const url = config?.url || '';
      const skipRedirectForPublicCalls =
        url.includes('/user/favorites/check') ||
        (url.includes('/user/favorites') && config?.method?.toLowerCase() === 'get');
      if (!skipRedirectForPublicCalls) {
        localStorage.removeItem('token');
        const redirect = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?redirect=${redirect}`;
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
